export const SET_POPUP = "SET_POPUP";
export const RESET_POPUP = "RESET_POPUP";

export function setPopup(popup) {
  return {
    type: SET_POPUP,
    popup
  };
}

export function resetPopup() {
  return {
    type: RESET_POPUP
  };
}
